// @flow strict
import * as React from 'react';

const CrossMark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23">
    <path
      d="M18.833 0l-.008.005L18.819 0l-4.53 4.766L11 8.216l-3.29-3.45L3.179 0l-.003.005L3.17 0v.01L0 3.242 7.872 11.5 0 19.759l3.17 3.23V23l.005-.005.003.005 4.502-4.731L11 14.785l3.32 3.484L18.819 23l.006-.005.008.005v-.01L22 19.758 14.13 11.5 22 3.241 18.833.011z"
      fill="#ECEAEA"
    />
  </svg>
);

export { CrossMark };
